export function eventTracker (event: string, product: any) {
    if (window?.umami !== undefined) {
        window.umami.track(event, { productId: product.id })
    }
    if (window?.posthog !== undefined) {
        window.posthog.capture(event, { productId: product.id })
    }
}

export function setPostHogCompany (companyUuid: string) {
    if (window?.posthog !== undefined) {
        window.posthog.group('company', companyUuid, {}) // the empty object is needed, else it does not pick up the group event
    }
}

export function setPostHogUser (userId: string) {
    if (window?.posthog !== undefined) {
        window.posthog.identify(userId)
    }
}

export function resetPostHogUser () {
    if (window?.posthog !== undefined) {
        window.posthog.reset()
    }
}
